<template>
  <coozzy-card
    class="mb-0">
    <div
      class="row align-items-center">
      <div class="col-6">
        <h4 class="card-title mb-0">
          {{ $t('message.settings.ailean.title') }}
        </h4>
      </div>
      <div class="col-6">
        <img
          src="@/assets/ailean.png"
          alt="ailean"
          class="img-ailean">
      </div>
    </div>
    <div class="row m-0">
      <div class="col-12">
        <coozzy-button
          class=""
          design="green"
          @click="forwardToAilean">
          {{ $t('message.settings.ailean.goToAilean') }}
        </coozzy-button>
      </div>
    </div>
  </coozzy-card>
</template>
<script lang="ts">
import CoozzyCard from '@/framework/components/card/CoozzyCard.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import Vue from 'vue'
import AileanApi from '@/misc/apis/AileanApi'

export default Vue.extend({
  name: 'AileanSettings',
  components: {
    CoozzyButton,
    CoozzyCard
  },
  methods: {
    forwardToAilean() {
      AileanApi.getSsoUrl().then((response) => {
        window.open(response.url, '_blank')
      }).catch((error) => {
        console.log(error)
      })
    }
  }
})
</script>
<style lang="scss" scoped>
.img-ailean {
  width: 120px;
  float: right;
}
</style>
